import React from "react";

interface TimelineItemProps {
  period: string;
  title: string;
  company: string;
  summary: string;
  bullets?: string[];
}

const TimelineItem: React.FC<TimelineItemProps> = ({
  period,
  title,
  company,
  summary,
  bullets,
}) => (
  <li className="mb-8 ml-4 last:mb-2">
    <div className="absolute -left-1.5 mt-1.5 h-3 w-3 rounded-full border border-slate-500 bg-slate-900 dark:bg-slate-50 dark:border-slate-400" />
    <div className="flex flex-wrap items-center justify-between gap-2">
      <h3 className="text-sm font-semibold text-slate-100 dark:text-slate-900">
        {title}
      </h3>
      <span className="rounded-full border border-slate-700 bg-slate-900 px-2 py-0.5 text-[11px] text-slate-300 dark:border-slate-300 dark:bg-slate-50 dark:text-slate-700">
        {period}
      </span>
    </div>
    <p className="mt-0.5 text-xs font-medium text-emerald-300 dark:text-emerald-700">
      {company}
    </p>
    <p className="mt-2 text-sm text-slate-300 dark:text-slate-700">{summary}</p>
    {bullets && (
      <ul className="mt-2 list-disc space-y-1 pl-4 text-xs text-slate-400 dark:text-slate-600">
        {bullets.map((b) => (
          <li key={b}>{b}</li>
        ))}
      </ul>
    )}
  </li>
);

export default TimelineItem;
